var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(" Thank You for Subscribing! ")]),_c('p',[_vm._v("If you have any questions or concerns regarding this, do not hesitate to contact us at adminuser@vidhyaan.com")])])
}]

export { render, staticRenderFns }